// extracted by mini-css-extract-plugin
export default {"card":"blogSubscribePrompt_card__8HmmU","heading":"blogSubscribePrompt_heading__Zjkhc","description":"blogSubscribePrompt_description__Ba1mh"};